// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';

// TYPES ---------------------------------------------------------------- //

export interface TagProps {
  id: string | number;
  element?: React.ReactElement;
  style?: React.CSSProperties;
}

// COMPONENT ---------------------------------------------------------------- //

const Tag = ({ element, style }: TagProps) => {
  if (!element) return null;
  return <div style={style}>{element}</div>;
};

// EXPORT ---------------------------------------------------------------- //

export default Tag;
